import utilsApi from '../assets/js/utils';
export default utilsApi.creatApi({
    // 获取当前用户历史订单
    getCurrentUserShopOrderList: ["post", "getCurrentUserShopOrderList"],
});